import React, { useMemo } from "react";
import { Col } from "react-bootstrap";
import Icofont from "../../../components/IcoFont";
import moment from "moment";
import classnames from "classnames";
import { useTrans } from "../../../hooks";
import _ from "lodash";

const TrackOrderStatusPickedUp = ({ order }) => {
  const transMsg = useTrans();
  const orderDone = useMemo(() => {
    return order.state === "PICKED_UP";
  }, [order]);

  const orderNext = useMemo(() => {
    return order.state === "READY_FOR_PICK_UP";
  }, [order]);

  return (
    <>
      <Col xl={3} lg={4} md={6} sm={12} className="py-2">
        <Icofont
          icon="bag"
          className={classnames("icofont-3x", {
            "text-primary": orderNext,
            "text-info": orderDone,
            "text-muted": !orderDone && !orderNext,
          })}
        />
        <div className="mt-1 font-weight-bold text-dark mb-0">
          {transMsg("orderPickedUp")}
        </div>
        {orderDone && (
          <div className="text-muted  font-weight-light">
            {moment(order.completedAt).format("MMMM Do YYYY, h:mm A")}
          </div>
        )}

        <div
          className={classnames("mb-0", {
            "text-primary": orderNext,
            "text-info": orderDone,
          })}
        >
          {orderDone && <>{_.upperCase(transMsg("done"))} </>}
          {orderNext && <>{_.upperCase(transMsg("next"))} </>}
        </div>
      </Col>
    </>
  );
};

export default TrackOrderStatusPickedUp;
